import styled, { createGlobalStyle } from "styled-components";

export const StyledHolidayContainer = styled.div`
  height:100%;
  width: 100%;
  header.tma_holiday_header{
    display: flex;
    margin-bottom: 0.5rem;
    justify-content:end;
    align-items:center;
    gap:1rem;
    flex-wrap: wrap;
    @media (max-width: 640px) {
      gap: 0.5rem;
    }
    label.tma__dropdown_label {display: none;}
    button[aria-label="Download List"] {
      transition: all 0.5 ease-in-out;
      padding: 0;
      svg {
        width: 35px;
        height: 35px;
        fill: var(--primary-text);
      }
      &:hover {
        svg {
          fill: var(--primary-text-hover);
        }
      }
    }
    button.tma_download_list{
      background-color: transparent;
      border: none;
      cursor: pointer;
      margin-right:10px;
    }
    button.tma_add_holiday{
       border-radius:5px;
       background-color: var(--primary-text);
       transition: all 0.5 ease-in-out;
       &:hover {
          background-color: var(--primary-text-hover);
      }
    }
    button#tma_years-filter{
      min-width: 150px;
      border-color: #ddd;
      border-radius: 3px;
      line-height: 1;
      height: 40px;
    }
}
  }
.tma_holiday_table {
  height: calc(100vh - 225px);
  .ag-theme-material {
    .ag-theme-checkboxStyle-1.ag-theme-iconSet-2.ag-theme-tabStyle-3.ag-theme-inputStyle-4 {
      overflow-x: auto;
      border: 1px solid #ddd;
      border-radius: 3px;
      .ag-root-wrapper.ag-ltr.ag-layout-normal {
        min-width: 1250px;
        border: none;
        border-radius: 0px;
        .ag-header-cell {
        .ag-header-cell-label {
          font-size: 13px;
          font-weight: 500;
        }
            &:last-child {
              .ag-header-cell-resize {
                &:after {display: none;}
              }
            }
        }
      }
    }
    .ag-center-cols-viewport {
    .ag-cell {
      font-size: 13px;
      &:last-child {
      div {gap: 0.5rem; align-items: center; display: flex; height: 100%;}
      button.tma_action_icon {
        display: flex;
        // border: 1px solid var(--primary-text);
        // border-radius: 100px;
        // background-color: var(--primary-text);
        // padding: 0.3rem;
        transition: all 0.3s ease-in-out;
        svg {height: 18px; width: 18px; fill: var(--primary-text);}
        &.delete {
        // background-color: var(--failed);
        // border-color: var(--failed);
          svg {
            fill: var(--failed);
          }
        }
          &:hover 
      }
      }
    }
      .ag-center-cols-container {
        .ag-row-no-focus.ag-row {
          &:nth-child(2n+1) {
            background-color: #f5f5f5;
          }
        }
      }
    }
      .MuiTablePagination-root {
        .MuiToolbar-root {padding: 0 !important;}
      }
  }
  &.projects {
    .ag-theme-material {
    .ag-theme-checkboxStyle-1.ag-theme-iconSet-2.ag-theme-tabStyle-3.ag-theme-inputStyle-4 {
      overflow-x: auto;
      border: 1px solid #ddd;
      border-radius: 3px;
      .ag-root-wrapper.ag-ltr.ag-layout-normal {
        // min-width: 860px;
        border: none;
        border-radius: 0px;
        .ag-header-cell {
        .ag-header-cell-label {
          font-size: 13px;
          font-weight: 500;
        }
            &:last-child {
              .ag-header-cell-resize {
                &:after {display: none;}
              }
            }
        }
      }
    } 
    } 
  }
}
`;
export const StyledActionRenderer = styled.div`
  dispaly: flex;
  button.tma_action_icon {
    background-color: transparent;
    border: none;
    color: var(--navy);
    cursor: pointer;
    svg {
      height: 20px;
    }
  }
`;
export const StyledFormSection = styled.section`
  form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
  }
  .tma_input_control {
    .MuiFormHelperText-root {
      margin-left: 0;
    }
    .tma__input_label,
    label {
      margin-bottom: 0.5rem;
    }
    .tma__input_container {
      .MuiFormControl-root {
        width: 100%;
      }
      .MuiInputBase-root {
        height: 40px;
        width: 100%;
        border-radius: 5px;
        fieldset {
          border-color: var(--input-border-color);
          border-radius: 5px;
        }
        &.Mui-error {
          fieldset {
            border-color: var(--mui-palette-error-main);
          }
        }
      }
    }
  }
  .tma_form_actions {
    width: 100%;
    button.tma_create_holiday_submit {
      width: 100%;
      border-radius: 5px;
    }
  }
`;
export const StyledCreateHolidayContainer = styled(StyledFormSection)`
  form.tma_holiday_create_form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
    button {
      &.tma_create_holiday_submit {
        background-color: var(--primary-text);
        height: 40px;
        transition: all 0.3s ease-in-out;
        &:hover {
          background-color: #1e409e;
        }
      }
    }
  }
`;
export const StyledCreateProjectTaskContainer = styled(StyledFormSection)`
height:100%;
  width: 100%;
  header.tma_prj_tasks_header{
    display: flex;
    margin-bottom: 0.5rem;
    button.tma_download_list{
      background-color: transparent;
      border: none;
      cursor: pointer;
      margin-left:auto;
      margin-right:10px;
    }
    button.tma_add_task{
       border-radius:5px;
    }
}
  }
`;

export const ModalDropDownStyles = createGlobalStyle`
.base-Select-popup{
  z-index:9999 !important;
}
`

export const StyledTabPanel = styled.div`
  padding: 1rem 0;
`